import React from "react";
import { observer } from "mobx-react-lite";
import { FormGroupWithRequired } from "./Components";
import { TimePicker } from "@blueprintjs/datetime";
import type { ITimeAttrEditorProps, EditorWithFormGroup } from "./_types";
export type { ITimeAttrEditorProps, EditorWithFormGroup } from "./_types";

// TimeAttrEditor
export const TimeAttrEditor = observer(<D, K extends keyof D>(props: ITimeAttrEditorProps<D, K>) => {
	const { store, ...rest } = props;

	let value = store.data[props.name] as Date | string;
	if (value && typeof value === "string") value = props.parseDate(value);

	// Change handler
	const onChange = (date: Date) => {
		if (props.timePickerProps?.onChange) props.timePickerProps.onChange(date);
		else store.set(props.name, props.formatDate(date));
	};

	// --

	return <TimePicker {...rest.timePickerProps} onChange={onChange} value={value as Date} />;
});

// TimeAttrEditorGrouo
export const TimeAttrEditorGroup = <D, K extends keyof D>(props: EditorWithFormGroup<ITimeAttrEditorProps<D, K>>) => {
	const { formGroupProps, ...rest } = props;

	// --

	return (
		<FormGroupWithRequired {...formGroupProps}>
			<TimeAttrEditor {...rest} />
		</FormGroupWithRequired>
	);
};
